import { BlockDefinition } from "@softr-io/blocks-sdk";

export function areBlockDefinitionsEqual(
    prev: BlockDefinition | undefined,
    next: BlockDefinition | undefined,
): boolean {
    if (!prev || !next) {
        return prev === next;
    }
    prev = { ...prev };
    next = { ...next };
    delete prev.updated;
    delete next.updated;
    return JSON.stringify(prev) === JSON.stringify(next);
}
